import { get_empresas } from '../../../../Services/empresa'

//Função que traz os dados do banco de dados
export const get = () =>{
    return[(dispatch,getState)=>{
        
        const order = getState().empresa.order
        const th = getState().empresa.th
        const qtd_per_page = getState().empresa.qtd_per_page
        const pesquisa = getState().empresa.pesquisa || '' 
        const page = getState().empresa.page      
      
        get_empresas(page,qtd_per_page,order,th,pesquisa)
        .then(resp=>dispatch({type:'Empresas', payload:resp.data}))

    }]
}

//Função que ordena as colunas
export const order = (coluna) => {
    return [(dispatch,getState)=>{
        const asc = getState().empresa.asc
      
        if(asc === true){
            dispatch({type:'GetEmpresa_Desc', desc:true, asc:false,order:'desc',th:coluna})
            
        }if(asc === false){
            dispatch({type:'GetEmpresa_Asc', asc:true, desc:false,order:'asc',th:coluna})
            
        }
     
    },get(1)]    
}

export const change_qtd_per_page = event => {
    return[{
        type:'qtd_per_page_empresa',
        payload:event.target.value
    },get(1)]
}

export const changePesquisa = event => {
    return[{
        type:'pesquisaEmpresa',
        payload:event.target.value
    }]
}

export const clearPesquisa = event => {
    return[{
        type:'clearPesquisaEmpresa',
        payload:''
    },get(1)]
}

export const changePage = page => {
    return[{
        type: 'changePageEmpresa',
        payload: page
    },get()]
}

export const search = () => {
    return [
        (dispatch, getState) => {
            const pesquisa = getState().empresa.pesquisa || ''
            if(pesquisa){
                return dispatch({type:'changePageEmpresa', payload:1})
            }
        }, get()
    ]
}

